class WholesaleBrowseGrid extends HTMLElement {
  constructor() {
    super();
    this.grid = this.querySelector('[data-wp-grid]');
    this.sortButtons = Array.from(this.querySelectorAll('[data-wp-sort]'));
    this.sortButtons.forEach((button) => {
      button.addEventListener('click', () => this.sortBy(button));
    });
  }

  sortBy(activeButton) {
    if (!this.grid) return;

    this.sortButtons.forEach((button) => {
      button.setAttribute('aria-pressed', button === activeButton ? 'true' : 'false');
    });

    const mode = activeButton.dataset.wpSort;
    const items = Array.from(this.grid.children);

    items.sort((a, b) => {
      const cardA = a.querySelector('.wp-card');
      const cardB = b.querySelector('.wp-card');

      if (mode === 'price') {
        return this.parsePrice(cardA) - this.parsePrice(cardB);
      }

      const createdA = parseInt(cardA && cardA.dataset.wpCreated, 10) || 0;
      const createdB = parseInt(cardB && cardB.dataset.wpCreated, 10) || 0;
      return createdB - createdA;
    });

    items.forEach((item) => this.grid.appendChild(item));
  }

  parsePrice(card) {
    const value = parseInt(card && card.dataset.wpPrice, 10);
    return Number.isNaN(value) ? Infinity : value;
  }
}

customElements.define('wholesale-browse-grid', WholesaleBrowseGrid);
